/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'
import {
    FacebookIcon,
    FacebookShareButton,
    LinkedinIcon,
    LinkedinShareButton,
    TwitterIcon,
    TwitterShareButton,
    EmailIcon,
    EmailShareButton,
    RedditIcon,
    RedditShareButton,
    WhatsappIcon,
    WhatsappShareButton
} from 'react-share'
import { v4 as uuidv4 } from 'uuid'

import * as ambassadorSelectors from '../selectors'
import './AmbassadorChallenge.less'
import { AmbassadorInfo } from './AmbassadorInfo/AmbassadorInfo.component'
import moment from 'moment'
import './AmbassadorChallenge.css'

interface ChallengeCardBlockProps {
    challengeObj: ChallengeDataRecord
    toggleModal?: () => void
    onAfterSocialShare?: any
    currentIndex: number
    getAmbassadorProfile?: any
    ambassadorProfile: AmbassadorProfileRecord
}
interface AmbassadorChallengeBlockProps {
    data: ChallengeDataRecord[]
    children?: any
    toggleModal?: () => void
    onPageChange?: any
    onAfterSocialShare?: any
    selectedChallengeIndex: number
    onAmbassadorProfile: boolean
    getAmbassadorProfile?: any
    ambassadorProfile: AmbassadorProfileRecord
    sortBy?: string
}

export const ChallengeTitleBlock = (challengeTitle: string) => {
    if (challengeTitle.length <= 50) {
        return <span>{challengeTitle}</span>
    }
    return (
        <span>
            {challengeTitle.slice(0, 50)}
            <span title={challengeTitle}>...</span>
        </span>
    )
}
export const ViewChallengeUrl = (ViewChallenge: string) => {
    let url = window.location.href
    if (ViewChallenge != null && ViewChallenge != undefined && ViewChallenge != "") {
        return url.split("pgid")[0] + `pgid=${ViewChallenge}`
    }
    return url;
}

interface FunctionsToProps {
    getConvertedCurrencyValue: (value: number) => string
    getDaysRemaining: (EndDate: string) => string
    getPercentageFunded: (currentValue: number, goalvalue: number) => number
    updateSelectedChallengeIndex: (index: number) => void
    updateOnAmbassadorProfile: (flag: boolean) => void
}

let prevSelectedChallengeId = -1

export const ChallengeCardBlock = (props: ChallengeCardBlockProps & FunctionsToProps) => {
    const {
        ChallengeName,
        ChallengeStartDate,
        ChallengeEndDate,
        NumberOfDonations,
        RaisedAmount,
        GoalAmount,
        GoalParticipation,
        ChallengeGoalType,
        DonationUrl,
        SocialShareUrl,
        CreateShareApiUrl,
        FacebookSnId,
        TwitterSnId,
        LinkedInSnId,
        RedditSnId,
        WhatsappSnId,
        EMailSnId,
        ChallengeImage,
        ViewChallenge,

    } = props.challengeObj

    const { getConvertedCurrencyValue, getPercentageFunded, onAfterSocialShare } = props
    const endDate = moment(ChallengeEndDate, "YYYY-MM-DD HH:mm:ss");
    const currentDate = moment();
    const difference = moment.duration(endDate.diff(currentDate));
    const days = isNaN(difference.days()) ? 0 : difference.days();
    const hours = isNaN(difference.hours()) ? 0 : difference.hours();
    const minutes = isNaN(difference.minutes()) ? 0 : difference.minutes();
    let formattedDifference = (days != 0 && days > 0) ? `${days} day${days !== 1 ? 's' : ''} ${hours} hr${hours !== 1 ? 's' : ''} ${minutes} min` :
        ((hours != 0 && hours > 0) ? `${hours} hr${hours !== 1 ? 's' : ''} ${minutes} min` : ((minutes != 0 && minutes > 0) ? `${minutes} min` : "Challenge has ended"));
    const [isSocialIconsVisible, setSocialIconsVisible] = useState(false);
    const toggleShare = () => {
        setSocialIconsVisible(!isSocialIconsVisible);
    };
    const isDonateBtnDisabled = ambassadorSelectors.isDonateBtnDisabled(ChallengeStartDate)
    const swagIdFacebook = uuidv4()
    const swagIdTwitter = uuidv4()
    const swagIdLinkedIn = uuidv4();
    const swagIdEmail = uuidv4();
    const swagIdReddit = uuidv4();
    const swagIdWhatsapp = uuidv4();
    let FundedPercentage = 0
    if (ChallengeGoalType !== 'Participation') {
        FundedPercentage = getPercentageFunded(RaisedAmount, GoalAmount)
    } else {
        FundedPercentage = getPercentageFunded(NumberOfDonations, GoalParticipation)
    }
    useEffect(() => {
        const elements = document.querySelectorAll('[aria-label="twitter"]');

        elements.forEach((el) => {
            const elPath = el.getElementsByTagName('path')[0];
            const eLCircle = el.getElementsByTagName('circle')[0];

            if (el && eLCircle) {
                elPath && elPath.removeAttribute('d');
                elPath && elPath.setAttribute("d", "M 41.116 18.375 h 4.962 l -10.8405 12.39 l 12.753 16.86 H 38.005 l -7.821 -10.2255 L 21.235 47.625 H 16.27 l 11.595 -13.2525 L 15.631 18.375 H 25.87 l 7.0695 9.3465 z m -1.7415 26.28 h 2.7495 L 24.376 21.189 H 21.4255 z");

                eLCircle && eLCircle.removeAttribute('fill');
                eLCircle && eLCircle.setAttribute('fill', '#000000');
            }
        });
    }, []);
    return (
        <>
            {ChallengeImage ? (
                <div className="col-md-4 col-sm-12 text-center" style={{ padding: "0px 0px 10px 0px" }} >
                    <div className="challenge-image-wrapper">
                        <img
                            data-test="campaignImage"
                            src={ChallengeImage || ''}
                            className="img-responsive challenge-image ratio ratio-16x9"
                            style={{ maxHeight: '500px', maxWidth: '100%' }}
                            alt={ChallengeImage ? 'Challenge cover' : 'Challenge cover not available'}
                        />
                    </div>
                    <div className="progress" style={{ height: '8px', backgroundColor: '#e9ecef', borderRadius: "unset" }}>
                        <div
                            role="progressbar"
                            style={{ width: `${FundedPercentage}%`, backgroundColor: '#198754' }}
                            aria-valuenow={FundedPercentage}
                            aria-valuemin={0}
                            aria-valuemax={100}
                        ></div>
                    </div>
                </div>
            ) : (
                <div className="col-md-4 col-sm-12 text-center">
                    <div className='row' style={{ marginBottom: "10px" }}>
                        <div className='col-md-12 col-sm-12' style={{ backgroundColor: "#D9D9D9", padding: "0px" }}>
                            <div className="challenge-image-wrapper" style={{ height: "200px" }}>
                                <img
                                    data-test="campaignImage"
                                    src={ChallengeImage || ''}
                                    className="img-responsive challenge-image ratio ratio-16x9"
                                    style={{ maxHeight: '500px', maxWidth: '100%', textAlign: "center" }}
                                />
                            </div>
                        </div>
                        <div className='col-md-12 col-sm-12' style={{ padding: "0px" }}>
                            <div className="progress" style={{ height: '8px', backgroundColor: '#e9ecef', borderRadius: "unset" }}>
                                <div
                                    role="progressbar"
                                    style={{ width: `${FundedPercentage}%`, backgroundColor: '#198754' }}
                                    aria-valuenow={FundedPercentage}
                                    aria-valuemin={0}
                                    aria-valuemax={100}
                                ></div>
                            </div>

                        </div>
                    </div>

                </div>)}
            <div className='col-md-8 col-sm-12 challenge-mobile challenge-desktop'>
                <div className="row" >
                    <div className="col-sm-12 col-md-12">
                        <div className="title text-justify">
                            <a
                                href={ViewChallengeUrl(ViewChallenge)}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: 'none', fontSize: 'x-large' }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    window.open(ViewChallengeUrl(ViewChallenge), '_blank');
                                }}
                            >
                                <strong>{ChallengeTitleBlock(ChallengeName)}</strong>
                            </a>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-12">
                        <div className="row text-center" style={{ marginTop: '10px' }}>

                            {ChallengeGoalType != "Participation" ?
                                (<>
                                    <div className="col-xs-6 col-sm-6 col-md-3 desktop-padding" style={{ textAlign: "left" }}>
                                        <div><strong style={{ fontSize: 'larger' }}>${getConvertedCurrencyValue(RaisedAmount)}</strong></div>
                                        <div style={{ fontSize: 'small', color: '#6C757D' }}>raised of ${GoalAmount} goal</div>
                                    </div>
                                    <div className="col-xs-6 col-sm-6 col-md-3 desktop-padding" style={{ textAlign: "left" }}>
                                        <div><strong style={{ fontSize: 'larger' }}>{NumberOfDonations > 0 ? NumberOfDonations : 0}</strong></div>
                                        <div style={{ fontSize: 'small', color: '#6C757D' }}>donors</div>
                                    </div>
                                </>) : (<>
                                    <div className="col-xs-6 col-sm-6 col-md-3 desktop-padding" style={{ textAlign: "left" }}>
                                        <div><strong style={{ fontSize: 'larger' }}>${getConvertedCurrencyValue(RaisedAmount)}</strong></div>
                                        <div style={{ fontSize: 'small', color: '#6C757D' }}>raised</div>
                                    </div>
                                    <div className="col-xs-6 col-sm-6 col-md-3 desktop-padding" style={{ textAlign: "left" }}>
                                        <div><strong style={{ fontSize: 'larger' }}>{NumberOfDonations > 0 ? NumberOfDonations : 0}</strong></div>
                                        <div style={{ fontSize: 'small', color: '#6C757D' }}>out of {GoalParticipation} donors have contributed </div>
                                    </div>
                                </>)
                            }
                            <div className="col-sm-12 col-md-6 desktop-padding" style={{ textAlign: "left", marginTop: "10px" }}>
                                {formattedDifference === "Challenge has ended" ?
                                    (<>
                                        <div><strong style={{ fontSize: 'larger' }}>{formattedDifference}</strong></div>
                                    </>) :
                                    (<>
                                        <div><strong style={{ fontSize: 'larger' }}>{formattedDifference}</strong></div>
                                        <div className="detail-label" style={{ fontSize: "12px", color: '#6c757d', marginTop: "0" }}>remaining</div>
                                    </>)}

                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-12" style={{ marginBottom: "20px" }}>
                        <div className="row" style={{ marginTop: '15px' }}>
                            <div className="col-xs-4 col-sm-4 col-md-3 desktop-padding" style={{ textAlign: "left" }}>
                                <button
                                    className="btn donateBtn"
                                    style={{ backgroundColor: '#198754' }}
                                    disabled={isDonateBtnDisabled}
                                >
                                    <a href={DonationUrl} target="_blank" style={{ color: '#FFFFFF', textDecoration: 'none' }}>
                                        Give Now
                                    </a>
                                </button>
                            </div>
                            <div className="col-xs-8 col-sm-8 col-md-9 desktop-padding" style={{ textAlign: "left" }}>
                                <div className="share-container">
                                    <div className="share-button" onClick={toggleShare}>
                                        Share <span>🔗</span>
                                    </div>
                                    <div className="social-icons" style={{ display: isSocialIconsVisible ? 'block' : 'none' }}>
                                        <FacebookShareButton
                                            className="socialShareBtn"
                                            onShareWindowClose={() =>
                                                onAfterSocialShare?.(`${CreateShareApiUrl}&swag=${swagIdFacebook}&sn=${FacebookSnId}`)
                                            }
                                            quote={`Hey friends! Help me make a difference by contributing to ${ChallengeName}. I've Created this Challenge to support the ${imod.cms.scoreboards.siteName}'s giving initiative! Every little bit counts!`}
                                            url={`${SocialShareUrl}&swag=${swagIdFacebook}&sn=${FacebookSnId}`}
                                        >
                                            <FacebookIcon size={32} round />
                                        </FacebookShareButton>

                                        <TwitterShareButton
                                            className="socialShareBtn"
                                            onShareWindowClose={() =>
                                                onAfterSocialShare?.(`${CreateShareApiUrl}&swag=${swagIdTwitter}&sn=${TwitterSnId}`)
                                            }
                                            title={`Hey friends! Help me make a difference by contributing to ${ChallengeName}. I've Created this Challenge to support the ${imod.cms.scoreboards.siteName}'s giving initiative! Every little bit counts!`}
                                            url={`${SocialShareUrl}&swag=${swagIdTwitter}&sn=${TwitterSnId}`}
                                        >
                                            <TwitterIcon size={32} round />
                                        </TwitterShareButton>

                                        <LinkedinShareButton
                                            className="socialShareBtn"
                                            onShareWindowClose={() =>
                                                onAfterSocialShare?.(`${CreateShareApiUrl}&swag=${swagIdLinkedIn}&sn=${LinkedInSnId}`)
                                            }
                                            title={`Hey friends! Help me make a difference by contributing to ${ChallengeName}. I've Created this Challenge to support the ${imod.cms.scoreboards.siteName}'s giving initiative! Every little bit counts!`}
                                            url={`${SocialShareUrl}&swag=${swagIdLinkedIn}&sn=${LinkedInSnId}`}
                                        >
                                            <LinkedinIcon size={32} round />
                                        </LinkedinShareButton>

                                        <RedditShareButton
                                            className="socialShareBtn"
                                            onShareWindowClose={() =>
                                                onAfterSocialShare?.(`${CreateShareApiUrl}&swag=${swagIdReddit}&sn=${RedditSnId}`)
                                            }
                                            title={`Hey friends! Help me make a difference by contributing to ${ChallengeName}. I've Created this Challenge to support the ${imod.cms.scoreboards.siteName}'s giving initiative! Every little bit counts!`}
                                            url={`${SocialShareUrl}&swag=${swagIdReddit}&sn=${RedditSnId}`}
                                        >
                                            <RedditIcon size={32} round />
                                        </RedditShareButton>

                                        <WhatsappShareButton
                                            className="socialShareBtn"
                                            onShareWindowClose={() =>
                                                onAfterSocialShare?.(`${CreateShareApiUrl}&swag=${swagIdWhatsapp}&sn=${WhatsappSnId}`)
                                            }
                                            title={`Hey friends! Help me make a difference by contributing to ${ChallengeName}. I've Created this Challenge to support the ${imod.cms.scoreboards.siteName}'s giving initiative! Every little bit counts!`}
                                            url={`${SocialShareUrl}&swag=${swagIdWhatsapp}&sn=${WhatsappSnId}`}
                                        >
                                            <WhatsappIcon size={32} round />
                                        </WhatsappShareButton>

                                        <EmailShareButton
                                            className="socialShareBtn"
                                            onShareWindowClose={() =>
                                                onAfterSocialShare?.(`${CreateShareApiUrl}&swag=${swagIdEmail}&sn=${EMailSnId}`)
                                            }
                                            subject={`Help me meet my Donation Challenge: ${ChallengeName}`}
                                            body={`Hey friends! Help me make a difference by contributing to ${ChallengeName}. I've Created this Challenge to support the ${imod.cms.scoreboards.siteName}'s giving initiative! Every little bit counts!`}
                                            url={`${SocialShareUrl}&swag=${swagIdEmail}&sn=${EMailSnId}`}
                                        >
                                            <EmailIcon size={32} round />
                                        </EmailShareButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}

export const AmbassadorChallengeBlock = (props: AmbassadorChallengeBlockProps & FunctionsToProps) => {
    const { data, onPageChange, onAfterSocialShare, getConvertedCurrencyValue, getPercentageFunded, getDaysRemaining, selectedChallengeIndex, updateSelectedChallengeIndex, onAmbassadorProfile, updateOnAmbassadorProfile, ambassadorProfile, getAmbassadorProfile, sortBy } = props

    const sortedData = sortBy == "name" ? data.sort((a, b) => a.ChallengeName.localeCompare(b.ChallengeName))
        : sortBy == "createdate" ? data.sort((a, b) => new Date(a.DateAdded || '').getTime() - new Date(b.DateAdded || '').getTime())
            : data.sort((a, b) => new Date(a.ChallengeStartDate).getTime() - new Date(b.ChallengeStartDate).getTime());

    const handlePageClick = (selectedItem: { selected: number; }) => {
        onPageChange(selectedItem.selected)
    }
    const getPageCount = (): number => {
        if (!data || data.length <= 0) {
            return 0
        }
        return (Math.floor(data[0].TotalRecords / 12) + (data[0].TotalRecords % 12 > 0 ? 1 : 0))
    }

    if (prevSelectedChallengeId !== selectedChallengeIndex) {
        prevSelectedChallengeId = selectedChallengeIndex
    }

    return (
        <div className="challenge-wrapper" style={{ padding: "5px 25px" }}>
            <div className='row' style={{ marginTop: "20px" }}>
                {sortedData.map((challengeObj: ChallengeDataRecord, index: number) => <ChallengeCardBlock {...props} currentIndex={index + 1} getPercentageFunded={props.getPercentageFunded} key={challengeObj.ChallengeId} challengeObj={challengeObj} onAfterSocialShare={onAfterSocialShare} updateSelectedChallengeIndex={updateSelectedChallengeIndex} getAmbassadorProfile={getAmbassadorProfile} ambassadorProfile={ambassadorProfile} />)}
            </div>
            <div className="IModulesPaginationWrapper text-center mt-4">
                <ReactPaginate
                    previousLabel={<span >Previous</span>}
                    nextLabel={<span >Next</span>}
                    breakLabel={<span className="btn btn-light btn-sm">...</span>}
                    breakClassName="break-me"
                    pageCount={getPageCount()}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName="pagination justify-content-center"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    disabledClassName="disabled"
                    data-test="reactPagination"
                />
            </div>
            {
                selectedChallengeIndex > 0 &&
                <div className="mt-5">
                    <div className="card shadow-sm">
                        <div className="card-body">
                            <AmbassadorInfo
                                data={data[selectedChallengeIndex - 1]}
                                getPercentageFunded={getPercentageFunded}
                                key={data[selectedChallengeIndex - 1].ChallengeId}
                                onAfterSocialShare={onAfterSocialShare}
                                getConvertedCurrencyValue={getConvertedCurrencyValue}
                                getDaysRemaining={getDaysRemaining}
                                toggleModal={() => {
                                    prevSelectedChallengeId = -1;
                                    updateSelectedChallengeIndex(-1);
                                    updateOnAmbassadorProfile(false);
                                }}
                                onAmbssadorProfile={onAmbassadorProfile}
                                ambassadorProfile={ambassadorProfile}
                            />
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}
